import { get as idbGet, set as idbSet, del as idbDel } from 'idb-keyval';

export const QUERY_CACHE_KEY = 'erp.query-cache.v2';

type AsyncStringStorage = {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem(key: string): Promise<void>;
};

function isTauriRuntime(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}

const idbStorage: AsyncStringStorage = {
  getItem: (key) => idbGet<string>(key).then((v) => v ?? null),
  setItem: (key, value) => idbSet(key, value),
  removeItem: (key) => idbDel(key),
};

let desktopStoragePromise: Promise<AsyncStringStorage> | null = null;

async function getDesktopStorage(): Promise<AsyncStringStorage> {
  desktopStoragePromise ??= import('@erp/native/tauri-adapter')
    .then((mod) => mod.createTauriQueryCacheStorage())
    .catch((err) => {
      console.warn('[offline] SQLite query cache unavailable, falling back to IndexedDB', err);
      return idbStorage;
    });
  return desktopStoragePromise;
}

export function createQueryCacheStorage(): AsyncStringStorage {
  return {
    async getItem(key) {
      if (!isTauriRuntime()) return idbStorage.getItem(key);
      return (await getDesktopStorage()).getItem(key);
    },
    async setItem(key, value) {
      if (!isTauriRuntime()) return idbStorage.setItem(key, value);
      return (await getDesktopStorage()).setItem(key, value);
    },
    async removeItem(key) {
      if (!isTauriRuntime()) return idbStorage.removeItem(key);
      return (await getDesktopStorage()).removeItem(key);
    },
  };
}

export async function removePersistedQueryCache(): Promise<void> {
  await idbStorage.removeItem(QUERY_CACHE_KEY).catch(() => undefined);
  if (isTauriRuntime()) {
    await (await getDesktopStorage()).removeItem(QUERY_CACHE_KEY).catch(() => undefined);
  }
}
